import React, { useState, useEffect } from "react";
import {
  Box,
  LinearProgress,
  Container,
  Typography,
  Slide,
} from "@material-ui/core";
import LOGO from "src/assets/svgs/logo.png";
import { CheckCircle } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import type { Theme } from "src/theme";

const useStyles = makeStyles((theme: Theme) => ({
  checkCircleIcon: {
    color: theme.palette.colors.green,
    fontSize: 48,
  },
  successMessage: {
    marginLeft: "1rem",
  },
}));

const PersonalizeSetupLoading: React.FC = () => {
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const classes = useStyles();

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 100);
      });
    }, 100);

    const cleanup = setTimeout(() => {
      clearInterval(timer);
    }, 100);

    if (progress === 100) {
      setIsLoading(false);
    }

    return () => {
      clearInterval(timer);
      clearTimeout(cleanup);
    };
  }, []);

  if (!isLoading) {
    return (
      <Container maxWidth="sm">
        <Box display="flex" justifyContent="center" alignItems="center" mb={6}>
          <img src={LOGO} alt="My Reseller Genie" height="100%" />
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center" mb={6}>
          <Slide direction="up" in={true} mountOnEnter unmountOnExit>
            <CheckCircle className={classes.checkCircleIcon} />
          </Slide>
        </Box>
        <Box width="100%" justifyContent="center">
          <Typography
            variant="body1"
            className={classes.successMessage}
            align="center"
          >
            Success! Let's get crackin' {String.fromCodePoint(0x1f680)}
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box
        height="9rem"
        display="flex"
        justifyContent="center"
        alignItems="center"
        mb={6}
      >
        <img src={LOGO} alt="My Reseller Genie" height="100%" />
      </Box>
      <Box width="100%" justifyContent="center">
        <Typography variant="body1" gutterBottom align="center">
          Creating your personalized set up now...
        </Typography>
        <LinearProgress variant="determinate" value={progress} />
      </Box>
    </Container>
  );
};

export default PersonalizeSetupLoading;
